const envApiUriMapping = {
  dev: 'http://localhost:5000',
  // The core API (deepsight-api) is not deployed to the Mapal DEV estate yet — this host is
  // reserved by convention and currently returns a gateway 404. Until it is deployed, a
  // 'mapal-dev' build serves the UI and reaches the agent/invoice-control APIs, but core API
  // calls and Cryptr login will fail. Tracked as a blocker on Mapal work item 49702.
  mapalDev: 'https://api.inpulse.dev.mapal-os.com',
  test: 'https://api-test.inpulse.ai',
  demo: 'https://api-demo.deepsight.io',
  staging: 'https://api-staging.inpulse.ai',
  prod: 'https://api.deepsight.io',
};

const envAppUriMapping = {
  dev: 'http://localhost:4000/',
  mapalDev: 'https://app.inpulse.dev.mapal-os.com/',
  test: 'https://app-test.inpulse.ai/',
  staging: 'https://app-staging.inpulse.ai/',
  prod: 'https://app.inpulse.ai/',
};

const envInpulseAgentApiUriMapping = {
  dev: 'http://localhost:8000',
  mapalDev: 'https://agent-api.inpulse.dev.mapal-os.com',
  test: 'https://agent-api.inpulse.dev.mapal-os.com',
  demo: 'https://agent-api.inpulse.pre.mapal-os.com',
  staging: 'https://agent-api.inpulse.pre.mapal-os.com',
  prod: 'https://agent-api.data.inpulse.ai',
};

const envInpulseInvoiceControlApiUriMapping = {
  dev: 'http://localhost:8080',
  mapalDev: 'https://invoice-control-api.inpulse.dev.mapal-os.com',
  test: 'https://invoice-control-api.inpulse.dev.mapal-os.com',
  demo: 'https://invoice-control-api.inpulse.pre.mapal-os.com',
  staging: 'https://invoice-control-api.inpulse.pre.mapal-os.com',
  prod: 'https://invoice-control-api.data.inpulse.ai',
};

const cryptrEnvMapping = {
  dev: {
    REACT_APP_CRYPTR_AUDIENCE: 'http://localhost:4000',
    REACT_APP_CRYPTR_BASE_URL: 'https://inpulse.authent.me',
    REACT_APP_CRYPTR_CLIENT_ID: '2266081f-17a6-42ed-a1c7-166a89878308',
    REACT_APP_CRYPTR_DEFAULT_REDIRECT_URI: 'http://localhost:4000/login',
    REACT_APP_CRYPTR_TENANT_DOMAIN: 'inpulse',
  },
  // Reuses the shared non-production Cryptr client. The redirect URI below must be allow-listed
  // on that client before login works from the Mapal DEV domain.
  mapalDev: {
    REACT_APP_CRYPTR_AUDIENCE: 'https://app.inpulse.dev.mapal-os.com',
    REACT_APP_CRYPTR_BASE_URL: 'https://inpulse.authent.me',
    REACT_APP_CRYPTR_CLIENT_ID: '2266081f-17a6-42ed-a1c7-166a89878308',
    REACT_APP_CRYPTR_DEFAULT_REDIRECT_URI: 'https://app.inpulse.dev.mapal-os.com/login',
    REACT_APP_CRYPTR_TENANT_DOMAIN: 'inpulse',
  },
  test: {
    REACT_APP_CRYPTR_AUDIENCE: 'https://app-test.inpulse.ai',
    REACT_APP_CRYPTR_BASE_URL: 'https://inpulse.authent.me',
    REACT_APP_CRYPTR_CLIENT_ID: '2266081f-17a6-42ed-a1c7-166a89878308',
    REACT_APP_CRYPTR_DEFAULT_REDIRECT_URI: 'https://app-test.inpulse.ai/login',
    REACT_APP_CRYPTR_TENANT_DOMAIN: 'inpulse',
  },
  staging: {
    REACT_APP_CRYPTR_AUDIENCE: 'https://app-staging.inpulse.ai',
    REACT_APP_CRYPTR_BASE_URL: 'https://inpulse.authent.me',
    REACT_APP_CRYPTR_CLIENT_ID: '2266081f-17a6-42ed-a1c7-166a89878308',
    REACT_APP_CRYPTR_DEFAULT_REDIRECT_URI: 'https://app-staging.inpulse.ai/login',
    REACT_APP_CRYPTR_TENANT_DOMAIN: 'inpulse',
  },
  prod: {
    REACT_APP_CRYPTR_AUDIENCE: 'https://app.inpulse.ai',
    REACT_APP_CRYPTR_BASE_URL: 'https://inpulse.authent.me',
    REACT_APP_CRYPTR_CLIENT_ID: 'de193f1d-d70e-443f-9c19-1c99eab6d72d',
    REACT_APP_CRYPTR_DEFAULT_REDIRECT_URI: 'https://app.inpulse.ai/login',
    REACT_APP_CRYPTR_TENANT_DOMAIN: 'inpulse',
  },
};

const sleekplanProductId = 844756167;

let baseApiUrl = '';
let baseInpulseAgentApiUrl = '';
let baseInpulseInvoiceControlApiUrl = '';
let baseAppUrl = '';
let cryptrConfig = {};
let sleekplanConfig = {};

if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_BUILD_ENV === 'production') {
  baseApiUrl = envApiUriMapping['prod'];
  baseInpulseAgentApiUrl = envInpulseAgentApiUriMapping['prod'];
  baseInpulseInvoiceControlApiUrl = envInpulseInvoiceControlApiUriMapping['prod'];
  baseAppUrl = envAppUriMapping['prod'];
  cryptrConfig = cryptrEnvMapping['prod'];
  sleekplanConfig.productId = sleekplanProductId;
} else if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_BUILD_ENV === 'demo') {
  baseApiUrl = envApiUriMapping['demo'];
  baseInpulseAgentApiUrl = envInpulseAgentApiUriMapping['demo'];
  baseInpulseInvoiceControlApiUrl = envInpulseInvoiceControlApiUriMapping['demo'];
  sleekplanConfig.productId = sleekplanProductId;
} else if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_BUILD_ENV === 'staging') {
  baseApiUrl = envApiUriMapping['staging'];
  baseInpulseAgentApiUrl = envInpulseAgentApiUriMapping['staging'];
  baseInpulseInvoiceControlApiUrl = envInpulseInvoiceControlApiUriMapping['staging'];
  baseAppUrl = envAppUriMapping['staging'];
  sleekplanConfig.productId = sleekplanProductId;
  cryptrConfig = cryptrEnvMapping['staging'];
} else if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_BUILD_ENV === 'test') {
  baseApiUrl = envApiUriMapping['test'];
  baseInpulseAgentApiUrl = envInpulseAgentApiUriMapping['test'];
  baseInpulseInvoiceControlApiUrl = envInpulseInvoiceControlApiUriMapping['test'];
  baseAppUrl = envAppUriMapping['test'];
  cryptrConfig = cryptrEnvMapping['test'];
  sleekplanConfig.productId = sleekplanProductId;
} else if (
  process.env.NODE_ENV === 'production' &&
  process.env.REACT_APP_BUILD_ENV === 'mapal-dev'
) {
  baseApiUrl = envApiUriMapping['mapalDev'];
  baseInpulseAgentApiUrl = envInpulseAgentApiUriMapping['mapalDev'];
  baseInpulseInvoiceControlApiUrl = envInpulseInvoiceControlApiUriMapping['mapalDev'];
  baseAppUrl = envAppUriMapping['mapalDev'];
  cryptrConfig = cryptrEnvMapping['mapalDev'];
  sleekplanConfig.productId = sleekplanProductId;
} else {
  baseApiUrl = envApiUriMapping['dev']; // Change here to put staging or dev
  baseInpulseAgentApiUrl = envInpulseAgentApiUriMapping['dev']; // Change here to put staging or dev
  baseInpulseInvoiceControlApiUrl = envInpulseInvoiceControlApiUriMapping['dev']; // Change here to put staging or dev
  baseAppUrl = envAppUriMapping['dev']; // Change here to put staging or dev
  cryptrConfig = cryptrEnvMapping['dev'];
  // Uncomment for testing purposes
  // sleekplanConfig.productId = sleekplanProductId;
}

export const config = {
  baseApiUrl,
  baseInpulseAgentApiUrl,
  baseInpulseInvoiceControlApiUrl,
  baseAppUrl,
  isProduction:
    process.env.NODE_ENV === 'production' && process.env.REACT_APP_BUILD_ENV === 'production',
  limitResponseTime:
    process.env.HEALTH_STATUS_LIMIT_RESPONSE_TIME_TO_CONSIDER_SLOW_CONNECTION_IN_MS || 2000,
  cryptr: cryptrConfig,
  sleekplan: sleekplanConfig,
};
